import React from "react";
import { Navigate } from "react-router-dom";

export const AddVendors = () => {
  return <Navigate to="/vendor?add_vendor=1" replace />;
};
